import type { SVGProps } from 'react'
const SvgTelegramLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.05 4.17C20 5.42 7 10.82 3.4 12.28c-2.41.94-.99 1.82-.99 1.82s2.06.7 3.82 1.23c1.77.53 2.72-.06 2.72-.06l8.27-5.58c2.93-2 2.23-.35 1.53.36a228 228 0 0 1-6.17 5.88c-.94.82-.47 1.52-.06 1.88 1.53 1.29 5.7 3.94 5.94 4.11 1.23.88 3.69 2.14 4.06-.53L24 12.16c.47-3.11.94-6 .98-6.81.18-2-1.94-1.18-1.94-1.18Z"
    />
  </svg>
)
export default SvgTelegramLogo
